(function($) {
    class W4D_Pagination {
        constructor() {
            this.initSelectors()
            this.bindEvents();
        }

        initSelectors() {
            this.productsContainer = $('.product-cards, .product-table');

            this.pagination = $('.pagination');
            this.paginationNext = $('.pagination__next');
            this.paginationPrev = $('.pagination__prev');
            this.paginationInput = $('.pagination--input');
            this.paginationTotal = $('.pagination--total');

            // Blog
            this.blogNavLink = $('.blog__nav-link');
            this.blogContainer = $('.blog-container');

            this.currentPage = parseInt(this.paginationInput.val());
            this.totalPages = parseInt(this.paginationTotal.text());

            if (document.body.classList.contains('search') && document.body.classList.contains('search-results')){
                this.smoothScrollToTop();
            }
        }

        bindEvents() {
            this.paginationNext.on('click', this.handleNextPageClick.bind(this));
            this.paginationPrev.on('click', this.handlePrevPageClick.bind(this));
            this.paginationInput.on('change', this.handleInputPageChange.bind(this));
            this.blogNavLink.on('click', (e) => this.handleBlogNavClick(e));
            window.addEventListener('popstate', this.handlePopState.bind(this));
        }

        handleBlogNavClick(e) {
            e.preventDefault();
            const clickedLink = $(e.currentTarget);
            const tag = $(e.currentTarget).data('tag');

            $('.blog__nav-link').removeClass('blog__nav-link--active');
            clickedLink.addClass('blog__nav-link--active');

            let currentCategory = W4D_FrontendHelper.getCurrentCategory();

            $.get({
                url: w4d_frontend_ajax.ajax_url,
                data: {
                    action: 'fetch_blog_posts',
                    nonce: w4d_frontend_ajax.nonce,
                    category: currentCategory,
                    tag: tag,
                    page: 1
                },
                beforeSend: () => {
                    this.blogContainer.addClass('load');
                },
                success: (response) => {
                    this.blogContainer.html(response.posts_html);
                    this.reinitPaginationSelectors();
                },
                error: (response) => {
                    console.error(response);
                    W4D_FrontendHelper.showNotice('error', 'Došlo je do pogreške');
                },
                complete: () => {
                    this.blogContainer.removeClass('load');
                }
            });
        }

        reinitPaginationSelectors() {
            this.pagination = $('.pagination');
            this.paginationNext = $('.pagination__next');
            this.paginationPrev = $('.pagination__prev');
            this.paginationInput = $('.pagination--input');
            this.paginationTotal = $('.pagination--total');

            this.currentPage = parseInt(this.paginationInput.val());
            this.totalPages = parseInt(this.paginationTotal.text());

            // Rebind events
            this.paginationNext.on('click', this.handleNextPageClick.bind(this));
            this.paginationPrev.on('click', this.handlePrevPageClick.bind(this));
            this.paginationInput.on('change', this.handleInputPageChange.bind(this));
        }

        handleNextPageClick(e) {
            e.preventDefault();
            this.handlePageChange(this.currentPage + 1);
        }

        handlePrevPageClick(e) {
            e.preventDefault();
            this.handlePageChange(this.currentPage - 1);
        }

        handleInputPageChange(e) {
            e.preventDefault();
            const pageInput = parseInt(e.target.value);

            if (pageInput >= 1 && pageInput <= this.totalPages) {
                this.handlePageChange(pageInput);
            } else if (pageInput > this.totalPages) {
                // Set input value to max pages if input exceeds total pages
                e.target.value = this.totalPages;
                this.handlePageChange(this.totalPages);
            } else {
                // Keep current page if input is invalid
                e.target.value = this.currentPage;
            }
        }

        handlePageChange(page) {
            if (page >= 1 && page <= this.totalPages) {
                this.updateURL(page);
                if (document.body.classList.contains('page-template-template-news')) {
                    this.fetchPosts(page);
                } else if (document.body.classList.contains('blog')) {
                    this.fetchBlogPosts(page);
                } else if (document.body.classList.contains('search') && document.body.classList.contains('search-results')) {
                   this.fetchProducts(page);
                   this.smoothScrollToTop();
                } else {
                    this.fetchProducts(page);
                    this.smoothScrollToTop();
                }
                this.paginationInput.val(page);
                this.currentPage = page;
            }
        }

        handlePopState(event) {
            if (event.state && event.state.page) {
                this.fetchProducts(event.state.page);
            } else {
                this.fetchProducts(this.getCurrentPageFromURL());
            }
        }

        updateURL(page) {
            const url = new URL(window.location);
            url.searchParams.set('page', page);
            window.history.pushState({page: page}, '', url);
        }

        getCurrentPageFromURL() {
            const urlParams = new URLSearchParams(window.location.search);
            return parseInt(urlParams.get('page')) || 1;
        }

        removePageFromURL() {
            const url = new URL(window.location.href);
            url.searchParams.delete('page');
            window.history.replaceState({}, '', url);
            this.currentPage = 1;
            this.paginationInput.val(this.currentPage);
        }

        disableFilters(disable) {
            // Handle Select2 dropdowns
            $('.js-basic-single, .js-basic-multiple').each(function() {
                const $select = $(this);
                if ($select.hasClass("select2-hidden-accessible")) {
                    $select.prop('disabled', disable);
                    $select.trigger('change.select2');

                    // Handle click events on select2 container
                    const $select2Container = $select.next('.select2-container');
                    if (disable) {
                        $select2Container.on('click.disableSelect mousedown.disableSelect', function(e) {
                            e.preventDefault();
                            e.stopImmediatePropagation();
                            return false;
                        });

                        // Also prevent the dropdown from opening
                        $select.select2('close');
                        $select.on('select2:opening.disableSelect', function(e) {
                            e.preventDefault();
                            return false;
                        });
                    } else {
                        $select2Container.off('.disableSelect');
                        $select.off('.disableSelect');
                    }
                }
            });

            // Shop archive buttons
            const $archiveButtons = $('.shop-archive__actions button');
            $archiveButtons.prop('disabled', disable);

            // Sort filter
            const $sortFilter = $('select[data-custom-taxonomy="sort"]');
            $sortFilter.prop('disabled', disable);
            const $sortContainer = $sortFilter.next('.select2-container');
            if (disable) {
                $sortContainer.on('click.disableSelect', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    return false;
                });
            } else {
                $sortContainer.off('click.disableSelect');
            }

            const $rangeSelect = $('.range-select');
            if (disable) {
                $rangeSelect.addClass('range-select--disabled');
                // Prevent trigger click and all other interactions
                $rangeSelect.on('click.disableSelect mousedown.disableSelect',
                    '.range-select__trigger, .js-range-trigger',
                    function(e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        return false;
                    });

                // Also prevent all interactions with inner elements
                $rangeSelect.on('click.disableSelect mousedown.disableSelect input.disableSelect change.disableSelect',
                    '.range-select__dropdown, .range-filter, .js-range-slider, .js-min-range, .js-max-range, .js-min-input, .js-max-input, .js-min-input-visible, .js-max-input-visible',
                    function(e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        return false;
                    });
            } else {
                $rangeSelect.removeClass('range-select--disabled');
                $rangeSelect.off('.disableSelect');
            }

            $('.js-reset-all').prop('disabled', disable);
            $('.filters__expand-btn').prop('disabled', disable);
        }

        updateUI(response) {
            this.productsContainer.toggleClass('load');
            $('.shop-archive__actions-icon').removeClass('shop-archive__actions-icon--disabled');
            this.disableFilters(false);
            this.updateProducts(response.products_html, response.is_wand_user,response.ident_name);
            this.updatePagination(response.max_num_pages);
            this.updateAvailableFilters(response.available_filters);
            this.updateStockFilters(response.stock_filters);
            W4D_FrontendHelper.checkFilterOverflow();
        }

        updateAvailableFilters(availableFilters) {
            let allFilters = $('.js-basic-multiple');

            allFilters.each(function() {
                let $filter = $(this);
                let taxonomy = $filter.data('custom-taxonomy');

                if (availableFilters[taxonomy]) {
                    let hasVisibleOptions = false;

                    $filter.find('option').each(function() {
                        let $option = $(this);
                        let optionValue = $option.val();
                        let quantity = availableFilters[taxonomy][optionValue] || 0;

                        $option.attr('data-quantity', quantity);
                        if (quantity > 0) {
                            hasVisibleOptions = true;
                        }
                    });

                    let $filterParent = $filter.closest('.filter');
                    $filterParent.toggle(hasVisibleOptions);

                    // Instead of destroying and reinitializing, just trigger a change
                    $filter.trigger('change.select2');
                } else {
                    if(taxonomy=="stock_status"){
                        $filter.closest('.filter').show();
                    }
                    else{
                        $filter.closest('.filter').hide();
                    }

                }
            });
        }

        updateStockFilters(stockFilters) {
            const $stockSelect = $('select[data-custom-taxonomy="stock_status"]');

            if (!stockFilters || typeof stockFilters !== 'object') return;

        $stockSelect.find('option').each(function() {
        const $option = $(this);
        const val = $option.val();

        const count = stockFilters[val] || 0;

        $option.attr('data-quantity', count);
        $option.prop('disabled', count === 0);

        // Clean existing text (remove previous (n) if any)
        const baseText = $option.text().replace(/\s\(\d+\)$/, '');
        $option.text(`${baseText}`);
    });

    // Trigger Select2 to update UI
    $stockSelect.trigger('change.select2');
}


        updateProducts(productsHtml, isWandUser, ident_name) {
            const viewType = isWandUser ? (W4D_FrontendHelper.getCookie('products_view_type') ?? 'grid') : 'grid';

            if (viewType === 'grid') {
                this.productsContainer
                    .removeClass('product-table')
                    .addClass('product-cards')
                    .html(productsHtml);
            } else {
                const tableHeader = '<div class="product-table__header">' +
                    '<div class="product-table__data">Naziv proizvoda</div>' +
                    '<div class="product-table__data">Dostupnost</div>' +
                    '<div class="product-table__data">'+ident_name+'</div>' +
                    '<div class="product-table__data">VP cijena</div>' +
                    '<div class="product-table__data">Količina</div>' +
                    '<div class="product-table__data">Iznos</div>' +
                '</div>';

                this.productsContainer
                    .removeClass('product-cards')
                    .addClass('product-table')
                    .html(isWandUser ? tableHeader + productsHtml : productsHtml);
            }
        }

        updatePagination(maxNumPages) {
            const previousTotalPages = this.totalPages;

            this.totalPages = maxNumPages;
            this.paginationTotal.text(maxNumPages);
            this.paginationInput.attr('max', maxNumPages);

            // If total pages changed (items per page was changed)
            if (previousTotalPages !== maxNumPages) {
                this.currentPage = 1;
                this.paginationInput.val(1);
            }

            this.pagination.toggleClass('pagination--hidden', maxNumPages <= 1);

            if (this.currentPage > maxNumPages) {
                this.currentPage = maxNumPages;
                this.paginationInput.val(maxNumPages);
            }

            this.paginationNext.toggleClass('pagination__next--inactive', this.currentPage >= maxNumPages);
            this.paginationPrev.toggleClass('pagination__prev--inactive', this.currentPage <= 1);
        }

        smoothScrollToTop() {
            const duration = 1000;
            const start = window.pageYOffset;
            const startTime = performance.now();

            const easeInOutQuad = t => {
                return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
            };

            const animate = (currentTime) => {
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);

                const easedProgress = easeInOutQuad(progress);
                const newPosition = start * (1 - easedProgress);

                window.scrollTo(0, newPosition);

                if (progress < 1) {
                    requestAnimationFrame(animate);
                }
            };

            requestAnimationFrame(animate);
        }

        disableShopArchiveHeaderActions() {
            $('.shop-archive__actions-icon').addClass('shop-archive__actions-icon--disabled');
        }

        fetchProducts(pageClick = false) {
            const searchParm=new URLSearchParams(window.location.search).get('s');

            let currentCategory = W4D_FrontendHelper.getCurrentCategory();
            let { filters, sort, page } = W4D_FrontendHelper.parseUrlParams();

            const isSearchResult=window.location.search.includes('dgwt_wcas=1');
            const isSortingActive=!!sort;
            const isPaginationClick=!!pageClick;

            if(isSearchResult && !isSortingActive && !isPaginationClick){
                return;
            }

            const ajaxData = {
                action: 'w4d_ajax_get_products',
                nonce: w4d_frontend_ajax.nonce,
                category: currentCategory,
                filters: JSON.stringify(filters),
                sort: sort,
                s:searchParm || ''
            }

            if (pageClick) {
                ajaxData.page = page;
                this.paginationInput.val(page);
            } else {
                this.removePageFromURL();
            }

            $.get({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                beforeSend: () => {
                    this.productsContainer.toggleClass('load');
                    this.disableFilters(true);
                    this.disableShopArchiveHeaderActions();
                },
                success: (response) => {
                    this.updateUI(response);
                },
                error: (error) => {
                    console.error('Error fetching filtered products:', error);
                    this.productsContainer.toggleClass('load');
                    this.disableFilters(false);
                    $('.shop-archive__actions-icon').removeClass('shop-archive__actions-icon--disabled');
                }
            });
        }

        fetchPosts(page) {
            let currentCategory = W4D_FrontendHelper.getCurrentCategory();

            const ajaxData = {
                action: 'fetch_news_posts',
                nonce: w4d_frontend_ajax.nonce,
                category: currentCategory,
                page: page
            }

            let postsGrid = $('.posts--grid');

            $.get({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                beforeSend: () => {
                    postsGrid.addClass('load');
                },
                success: (response) => {
                    postsGrid.html(response.posts_html);
                    this.reinitPaginationSelectors();
                },
                error: (error) => {
                    console.error('Error fetching posts:', error);
                },
                complete: () => {
                    postsGrid.removeClass('load');
                }
            });
        }

        fetchBlogPosts(page) {
            let currentCategory = W4D_FrontendHelper.getCurrentCategory();
            let blogContainer = $('.blog-container');

            const ajaxData = {
                action: 'fetch_blog_posts',
                nonce: w4d_frontend_ajax.nonce,
                category: currentCategory,
                page: page
            }

            $.get({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                beforeSend: () => {
                    blogContainer.addClass('load');
                },
                success: (response) => {
                    blogContainer.html(response.posts_html);
                    this.reinitPaginationSelectors();
                },
                error: (error) => {
                    console.error('Error fetching blog posts:', error);
                },
                complete: () => {
                    blogContainer.removeClass('load');
                }
            });
        }
    }

    $(document).ready(function() {
        window.W4D_Pagination = new W4D_Pagination();
    });
})(jQuery);